import classNames from 'classnames';
import React, { useId } from 'react';
import { Icon } from '../icon/icon';
import { Typography } from '../typography/typography';
import { notNil } from '../../core/helpers/is-nil';
import styles from './search-field.module.scss';

type Props = {
  variant: 'big' | 'small';
  placeholderText: string;
  actionText: string;
  helperText?: string;
  isDirty?: boolean;
} & React.InputHTMLAttributes<HTMLInputElement>;

export const SearchField: React.FC<Props> = ({
  variant,
  placeholderText,
  actionText,
  helperText,
  isDirty = false,
  ...rest
}) => {
  const helperId = useId();

  const isSmallVariant = variant === 'small';
  const hasHelper = notNil(helperText);

  return (
    <div className={classNames(styles.root, { [styles.small]: isSmallVariant })}>
      <div className={styles.inputContainer}>
        <input
          aria-describedby={hasHelper ? helperId : undefined}
          className={classNames(styles.input, { [styles.isDirty]: isDirty, [styles.small]: isSmallVariant })}
          placeholder={placeholderText}
          type="text"
          {...rest}
        />
        <button aria-label={actionText} className={styles.searchIconButton}>
          <Icon
            className={classNames(styles.icon, { [styles.small]: isSmallVariant })}
            size="32"
            variant="magnifying-glass"
          />
        </button>
      </div>
      {hasHelper ? (
        <Typography id={helperId} tag="span" variant="smalltext">
          {helperText}
        </Typography>
      ) : null}
    </div>
  );
};
